exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#write-in{min-height:380px}#write-in .col{max-width:50px;padding-left:5px;padding-right:5px}#write-in input.character{padding:0;text-transform:uppercase;text-align:center}#write-in input[readonly].non-alphanumeric{background-color:#ccc}#write-in input[readonly]{background:#fff}", ""]);

// exports
